module.exports = __webpack_public_path__ + "img/kolor-21.ea3fee99.png";